import { HiPhone } from "react-icons/hi2";

export const PhoneIcon = ({ width, height, color, ...props }) => (
  <HiPhone
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
